/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable import/prefer-default-export */
/* global window */

import * as _ from 'lodash';

import SessionService from '../../../apiServices/SessionService';
import { actions as systemNotificationActions } from './systemNotification';
import { actions as groupActions } from './group';
import { actions as notificationActions } from './notifications';
import { actions as actionItemActions } from './actionItems';
// import ShareCardActions from '../../appAuthorized/redux/ShareCardActions';
// import { ShareCardDefinitionsActions } from '../../appAuthorized/redux/ShareCardDefinitionsActions';
import { actions as listActions } from '../../redux/ducks/lists/lists';
import { actions as policyActions } from '../../redux/ducks/policy';
import { actions as consentActions } from '../../redux/ducks/consent';
import AppUtils from '../../../utilities/AppUtils';
import SystemService from '../../../apiServices/SystemService';

export const types = {
  TOKEN_REFRESHED: 'app/session/TOKEN_REFRESHED',
  RECEIVE_VERSION_CHECK: 'app/session/RECEIVE_VERSION_CHECK',
};

const initialState = {
  lastUpdated: 0,
  isUpdateAvailable: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.TOKEN_REFRESHED:
      return _.assign({}, state, action.payload);
    case types.RECEIVE_VERSION_CHECK:
      return _.assign({}, state, {
        isUpdateAvailable: action.payload.isUpdateAvailable,
      });
    default:
      return state;
  }
}


function login(credentials, callback) {
  return (dispatch) => {
    SessionService.login(credentials, (apiError) => {
      if (apiError && !apiError.messageKey()) {
        dispatch(systemNotificationActions.showNotification(apiError.responseMessage()));
      }
      callback(apiError);
    });
  };
}

function tokenRefreshed() {
  return {
    type: types.TOKEN_REFRESHED,
    payload: {
      lastUpdated: +new Date(),
    },
  };
}

function refreshToken(callback) {
  return (dispatch) => {
    SessionService.refresh((apiError, session) => {
      if (!apiError) {
        dispatch(tokenRefreshed());
      }

      callback(apiError, session);
    });
  };
}

function versionCheck() {
  return (dispatch) => {
    return SystemService.versionCheck().then((res) => {
      dispatch({
        type: types.RECEIVE_VERSION_CHECK,
        payload: {
          isUpdateAvailable: res.changes.length > 0,
          data: res,
        }
      });
      return res;
    });
  }
}

function clearNotificationTimer() {
  if (window.NOTIFICATION_TIMER) {
    clearTimeout(window.NOTIFICATION_TIMER);
    window.NOTIFICATION_TIMER = null;
  }
}

function startNotificationTimer(dispatch, failureCount) {
  window.NOTIFICATION_TIMER = setTimeout(() => {
    dispatch(notificationActions.requestCount())
    .then(() => {
      clearNotificationTimer();
      startNotificationTimer(dispatch, 4);
    })
    .catch((apiError) => {
      clearNotificationTimer();
      const newFailureCount = apiError.isUnauthorized() ? (failureCount - 1) : failureCount;

      if (newFailureCount < 1) {
        AppUtils.logout({}, () => { AppUtils.reloadApp(); });
      } else {
        startNotificationTimer(dispatch, newFailureCount);
      }
    });
  }, 5000);
}

function normalCountInterval(dispatch) {
  let failureCount = 4;

  clearNotificationTimer();
  startNotificationTimer(dispatch, failureCount);
}

function loadRequiredData(user, callback) {
  return (dispatch) => {
    const profileId = user.profile_id;
    const userId = user.id;
    dispatch(notificationActions.requestCount());

    const promises = [
      dispatch(listActions.loadAll()),
      dispatch(groupActions.requestGroups(profileId)),
      dispatch(actionItemActions.requestActionItems(userId, profileId)),
      dispatch(policyActions.requestAllPolicies()),
      dispatch(consentActions.requestAllConsents(profileId)),
      // ShareCardActions.loadAll(profileId),
      // ShareCardDefinitionsActions.load(profileId),
    ];

    if (user.intent) {
      promises.push(dispatch(groupActions.requestGroupById(user.intent.join_group.group_id)));
    }
    Promise.all(promises).then(() => {
      normalCountInterval(dispatch);
      callback();
    });
  };
}

export const selectors = {
  getLastUpdated: state => state.session.lastUpdated,
  isUpgradeAvailable: state => {
    return IS_ANDROID_BUILD && state.session.isUpdateAvailable;
  }
};

export const actions = {
  login,
  loadRequiredData,
  refreshToken,
  versionCheck,
};
